import { create } from 'zustand';

/** Resolved detail for the currently-selected PoP (fed by the scene). */
export interface SelectedPop {
  readonly id: string;
  readonly name: string;
  readonly regionCode: string;
  readonly capacityGbps: number;
  readonly online: boolean;
}

interface SelectionState {
  /** PoP id under the pointer, or null. High-frequency; drives hover highlight. */
  readonly hoveredId: string | null;
  /** The committed selection (click), or null. Drives the selection HUD + highlight. */
  readonly selected: SelectedPop | null;

  setHovered: (id: string | null) => void;
  select: (pop: SelectedPop | null) => void;
  clear: () => void;
}

/**
 * Selection store (see docs/FRONTEND_PLAN.md).
 * Hover is transient; selection is committed on click and surfaced in the HUD.
 */
export const useSelectionStore = create<SelectionState>((set) => ({
  hoveredId: null,
  selected: null,
  setHovered: (hoveredId) => set({ hoveredId }),
  select: (selected) => set({ selected }),
  clear: () => set({ selected: null }),
}));
